"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.evalExpression = exports.RGE_VAR_NAME = exports.REG_UTILS_PATH = exports.REG_FUNCTION_PATH = exports.REG_EXPRESSION_PATH = void 0;
exports.runExpression = runExpression;

var _tools = require("./tools");

var filters = _interopRequireWildcard(require("./evalFilters"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * 执行条件
 * @param {string} expression  判断条件
 * @param {object} data        数据
 * @return {boolean}
 */
var evalExpression = function evalExpression(expression, data) {
  try {
    /* eslint-disable-next-line */
    var fn = new Function('data', 'utils', "with(data) {\n        ".concat(Object.keys(data).map(function (key) {
      return "var ".concat(key, " = data['").concat(key, "'];");
    }).join(''), "\n        ").concat(/^\s*return\b/.test(expression) ? '' : 'return ').concat(expression, ";\n      }"));
    data = data || {};
    return fn.call(null, data, filters);
  } catch (error) {
    console.error(error);
    console.info("with(data) {\n      ".concat(Object.keys(data).map(function (key) {
      return "var ".concat(key, " = data['").concat(key, "'];");
    }).join(''), "\n      ").concat(/^\s*return\b/.test(expression) ? '' : 'return ').concat(expression, ";\n    }"));
    return false;
  }
};
/* eslint-disable-next-line */


exports.evalExpression = evalExpression;
var REG_EXPRESSION_PATH = /([a-zA-Z0-9_\.\[\]]+)\s*([<>!=]+)\s*([a-zA-Z0-9_\'\"]+)/g;
/* eslint-disable-next-line */

exports.REG_EXPRESSION_PATH = REG_EXPRESSION_PATH;
var REG_UTILS_PATH = /(utils\.[a-zA-Z0-9_]+\()([a-zA-Z0-9_\.\[\]]+)(.*?\))/g; // reg function

/* eslint-disable-next-line */

exports.REG_UTILS_PATH = REG_UTILS_PATH;
var REG_FUNCTION_PATH = /^\(function\(\)\{(.+)\}\)\(\);?$/;
/* eslint-disable-next-line */

exports.REG_FUNCTION_PATH = REG_FUNCTION_PATH;
var RGE_VAR_NAME = /\$([a-zA-Z0-9_\.\[\]]+)/g;
exports.RGE_VAR_NAME = RGE_VAR_NAME;

function runExpression(expression, formData) {
  var result = {
    result: undefined,
    value: undefined,
    wprops: undefined
  }; // 匹配(function{})()

  if (/^\(function\(\)\{(.+)\}\)\(\);?$/.test(expression)) {
    var evalResult = evalExpression(expression, formData);

    if ((0, _tools.isObject)(evalResult)) {
      result = evalResult;
    } else if (typeof evalResult === 'boolean') {
      result.result = evalResult;
    }

    return result;
  } // xx === '1'
  // eslint-disable-next-line no-useless-escape


  if (/([a-zA-Z0-9_\.\[\]]+)\s*([<>!=]+)\s*([a-zA-Z0-9_\'\"]+)/g.test(expression)) {
    result.result = evalExpression(expression, formData);
    return result;
  } // 匹配工具路径 utils.getXxx(path)
  // eslint-disable-next-line no-useless-escape


  if (/(utils\.[a-zA-Z0-9_]+\()([a-zA-Z0-9_\.\[\]]+)(.*?\))/g.test(expression)) {
    var utilsResult = evalExpression(expression, formData);

    if ((0, _tools.isObject)(utilsResult)) {
      result = utilsResult;
    } else if (typeof utilsResult === 'boolean') {
      result.result = utilsResult;
    }

    return result;
  }
}